import { Model } from "@bryntum/schedulerpro";
import {HasProjectMixin} from "./mixins/HasProjectMixin.jsx";

// tagSet could be "category", "tag", "status"
export class TagValue extends HasProjectMixin(Model) {
  static get $name() {
    return "TagValue";
  }

  static get fields() {
    return [
      { name: "tagSet", dataSource: "tag_set" },
      "order",
      // Note: renaming this to `tagValue` from `value` as bryntum 5.5 conflict with `value` and may be reserved
      { name: "tagValue", dataSource: "value" },
      { name: "notifyees", defaultValue: [] },
    ];
  }
}

TagValue.exposeProperties();
